<template>
  <div class="main">
    <div class="main-content d-flex">
      <div class="sidebar-wrapper d-none d-md-block">
        <SideMenu />
      </div>
      <div class="content d-flex flex-column flex-fill">
        <transition name="fade" mode="out-in">
          <router-view
            :key="$route.fullPath.toString()"
            class="router-content flex-fill px-5 pb-5"
          />
        </transition>
        <FooterMenu class="footer-menu d-flex d-md-none" />
      </div>
    </div>
  </div>
</template>

<script>
import FooterMenu from "../../components/FooterMenu";
import SideMenu from "@/components/SideMenu";
import Api from "api-client/index";

export default {
  components: {
    SideMenu,
    FooterMenu
  },
  created() {
    let self = this;
    Api.getMyEnabledCompanies()
      .then((companyResponse) => {
        self.$store.dispatch("app/addCompanyList", companyResponse.data);
      })
      .catch(() => {
        // self.$toast.error({
        //     title: self.$cte('login.companiesQueryFailedTitle'),
        //     message: self.$cte('login.companiesQueryFailedMessage')
        // });
      });

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
};
</script>

<style lang="scss" scoped>
$footer-height: 75px;

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.main {
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  background-color: transparent;
}

.sidebar-wrapper {
  background-color: transparent;
}

.main-content {
  height: 100%;
}

.content {
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100%;
}

.router-content {
  overflow-y: auto;
}

.footer-menu {
  height: $footer-height;
  min-height: $footer-height;
  width: 100%;
}

::v-deep(.nav-pills) {
  flex-wrap: nowrap !important;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

::v-deep(.nav-pills .nav-item) {
  flex: 0 0 auto;
}

::v-deep(.nav-pills::-webkit-scrollbar) {
  display: none;
}

</style>
